var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('carousel'),(_vm.user == null)?_c('div',[_c('register')],1):_c('div',[_c('upload')],1),_vm._l((_vm.datelist),function(date){return _c('photoBlock',{key:date.date,attrs:{"p_date":date}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }